export default __webpack_public_path__ + "media/src/assets/images/labelInfo-ac2478ab862136113f651cb04187f003.svg";